import { useMemo } from 'react';
import { ActivateMembershipRewardModal, MembershipReward } from '.';
import './MembershipProgress.css';
import { MembershipModel } from '../../models';
import { useMembershipReward } from '../../hooks';
import { getMembershipStyle } from '../../utils';

export function MembershipProgress(props: { membership: MembershipModel; total: number; current: number; redeemed: boolean; allowRedeem: boolean }) {
   const { total, current, membership, redeemed, allowRedeem } = props;
   const { isLoading, redeemFreeMonth, activateOpen, setActivateOpen } = useMembershipReward(membership.id);

   const membershipStyle = useMemo(() => {
      return getMembershipStyle(membership.type);
   }, [membership]);

   return (
      <div className="flex flex-col gap-1">
         <>
            <ActivateMembershipRewardModal
               isOpen={activateOpen}
               onClose={() => setActivateOpen(false)}
               membership={membership}
               icon={membershipStyle.icon}
               onSubmit={redeemFreeMonth}
               isLoading={isLoading}
            />
            <div className="flex justify-between bg-gray membership-progress-container">
               {Array.from({ length: total }, (_, index) => (
                  <div
                     key={index}
                     className={`membership-progress-bar-item flex-1 filled ${index === total - 1 ? 'end' : ''}`}
                     style={
                        index < Math.min(current, total)
                           ? {
                                backgroundColor: membershipStyle.color,
                                transitionDelay: `${index * 0.1}s`, // Staggered animation
                             }
                           : {
                                backgroundColor: '#151716',
                             }
                     }
                  />
               ))}

               <div
                  onClick={() => {
                     if (allowRedeem) setActivateOpen(true);
                  }}>
                  <MembershipReward
                     icon={membershipStyle.icon}
                     name={membership.name}
                     absolute
                     disabled={!allowRedeem || redeemed}
                  />
               </div>
            </div>

            <div className="flex justify-center">
               {!redeemed ? (
                  !allowRedeem ? (
                     <span className="gray">
                        {Math.min(current, total)}/{total} Referrals
                     </span>
                  ) : (
                     <span className="gray">Tap to activate</span>
                  )
               ) : (
                  <span className="gray">Already activated</span>
               )}
            </div>
         </>
      </div>
   );
}
